(function () {
  'use strict';

  // Config injected globally in theme.liquid (service variant ids + drive url).
  var CFG = window.__BRANDING_CONFIG || { driveUrl: '', serviceVariants: [] };
  var SERVICE_VARIANTS = (CFG.serviceVariants || []).map(Number).filter(Boolean);

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', count > 0);
    });
  }

  function openCartDrawer() {
    var trigger = document.querySelector('.js-drawer-open-cart');
    if (trigger) trigger.click();
  }

  function genRef() {
    return 'bref_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function removeLineKeys(keys) {
    // Remove sequentially by line key (keys are stable across changes).
    return keys.reduce(function (chain, key) {
      return chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
      });
    }, Promise.resolve());
  }

  // ---- Product page selector -------------------------------------------------

  function initSelector() {
    var root = document.querySelector('[data-branding-selector]');
    if (!root) return;

    var driveUrl   = root.getAttribute('data-drive-url') || CFG.driveUrl || '';
    var partTitle  = root.getAttribute('data-part-title') || '';
    var rows       = Array.prototype.slice.call(root.querySelectorAll('[data-branding-option]'));
    var uploadWrap = root.querySelector('[data-branding-upload]');
    var fileInput  = root.querySelector('[data-branding-file-input]');
    var dropBtn    = root.querySelector('[data-branding-drop]');
    var fileListEl = root.querySelector('[data-branding-file-list]');
    var errorEl    = root.querySelector('[data-branding-error]');
    var guidanceEl = root.querySelector('[data-branding-guidance]');

    var errorDefault = errorEl ? errorEl.textContent : '';
    var selected = null;      // the selected row element (or null = None)
    var uploadedLinks = [];   // ["logo.svg: https://drive...", ...]
    var pending = [];         // in-flight upload promises

    function showError() {
      if (errorEl) { errorEl.textContent = errorDefault; errorEl.hidden = false; }
      if (uploadWrap) { uploadWrap.classList.add('is-missing'); uploadWrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
    function clearError() {
      if (errorEl) errorEl.hidden = true;
      if (uploadWrap) uploadWrap.classList.remove('is-missing');
    }
    function clearFiles() {
      uploadedLinks = [];
      pending = [];
      if (fileListEl) fileListEl.innerHTML = '';
      clearError();
    }

    function selectRow(row) {
      rows.forEach(function (r) {
        var cb = r.querySelector('.branding-checkbox');
        cb.checked = (r === row);
      });
      selected = row;
      clearFiles();
      if (uploadWrap) uploadWrap.hidden = false;
      if (guidanceEl) guidanceEl.textContent = row.getAttribute('data-guidance') || '';
    }

    function deselectAll() {
      rows.forEach(function (r) { r.querySelector('.branding-checkbox').checked = false; });
      selected = null;
      clearFiles();
      if (uploadWrap) uploadWrap.hidden = true;
    }

    rows.forEach(function (row) {
      var cb = row.querySelector('.branding-checkbox');
      cb.addEventListener('change', function () {
        if (cb.checked) selectRow(row); else deselectAll();
      });
    });

    // ---- accepted artwork types, per service ----
    // Laser burns a single tone into the surface, so it needs line art and a
    // photo cannot be marked. UV is a full colour print, so photographs and
    // JPEGs are perfectly valid there. The accept attribute only governs the
    // browse dialog, and drag and drop bypasses it, so every file is checked here.
    var LASER_EXT = ['svg', 'ai', 'eps', 'pdf', 'png'];
    var UV_EXT    = ['svg', 'ai', 'eps', 'pdf', 'png', 'jpg', 'jpeg'];

    function allowedFor(row) {
      if (!row) return LASER_EXT;
      var attr = (row.getAttribute('data-accept') || '').toLowerCase();
      if (attr) {
        return attr.split(',').map(function (x) { return x.trim().replace(/^\./, ''); }).filter(Boolean);
      }
      var brand = (row.getAttribute('data-branding') || '').toLowerCase();
      return brand.indexOf('uv') !== -1 ? UV_EXT : LASER_EXT;
    }

    function fileExt(name) {
      var m = /\.([a-z0-9]+)$/i.exec(name || '');
      return m ? m[1].toLowerCase() : '';
    }

    function rejectFile(name, ext, isLaser) {
      var isJpeg = (ext === 'jpg' || ext === 'jpeg');
      var row = document.createElement('div');
      row.className = 'product-addon__file is-error';
      var nameEl = document.createElement('span');
      nameEl.className = 'product-addon__file-name';
      nameEl.textContent = name;
      var statusEl = document.createElement('span');
      statusEl.className = 'product-addon__file-status';
      statusEl.textContent = (isJpeg && isLaser) ? 'JPEGs are not accepted' : 'File type not accepted';
      var removeEl = document.createElement('button');
      removeEl.type = 'button';
      removeEl.className = 'product-addon__file-remove';
      removeEl.setAttribute('aria-label', 'Remove file');
      removeEl.innerHTML = '&times;';
      removeEl.addEventListener('click', function () { row.remove(); });
      row.appendChild(nameEl); row.appendChild(statusEl); row.appendChild(removeEl);
      if (fileListEl) fileListEl.appendChild(row);
      if (errorEl) {
        errorEl.textContent = (isJpeg && isLaser)
          ? 'JPEGs are not accepted for laser marking. Laser needs vector artwork: SVG, AI, EPS, PDF or PNG. If you want full colour from a photo, choose UV Printing instead.'
          : 'That file type is not accepted. Please upload SVG, AI, EPS, PDF or PNG.';
        errorEl.hidden = false;
      }
      if (uploadWrap) uploadWrap.classList.add('is-missing');
    }

    // ---- upload ----
    function renderRow(name) {
      var row = document.createElement('div');
      row.className = 'product-addon__file';
      var nameEl = document.createElement('span');
      nameEl.className = 'product-addon__file-name';
      nameEl.textContent = name;
      var statusEl = document.createElement('span');
      statusEl.className = 'product-addon__file-status';
      statusEl.textContent = 'Uploading...';
      var removeEl = document.createElement('button');
      removeEl.type = 'button';
      removeEl.className = 'product-addon__file-remove';
      removeEl.setAttribute('aria-label', 'Remove file');
      removeEl.innerHTML = '&times;';
      row.appendChild(nameEl); row.appendChild(statusEl); row.appendChild(removeEl);
      if (fileListEl) fileListEl.appendChild(row);
      return {
        setDone: function (link) {
          row.classList.add('is-done');
          statusEl.textContent = 'Uploaded';
          if (link) uploadedLinks.push(link);
          removeEl.addEventListener('click', function () {
            if (link) uploadedLinks = uploadedLinks.filter(function (l) { return l !== link; });
            row.remove();
          });
        },
        setError: function () {
          row.classList.add('is-error');
          statusEl.textContent = 'Upload failed, please try again';
          removeEl.addEventListener('click', function () { row.remove(); });
        }
      };
    }

    function readAsPayload(file) {
      return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onload = function (ev) {
          var base64 = ev.target.result.split(',')[1];
          var savedName = (partTitle ? partTitle + ' - ' : '') + file.name;
          resolve({ filename: savedName, mimeType: file.type || 'application/octet-stream', data: base64 });
        };
        reader.readAsDataURL(file);
      });
    }

    function uploadFiles(fileList) {
      if (!driveUrl || !selected) return;
      var folder = selected.getAttribute('data-folder') || '';
      var allowed = allowedFor(selected);
      var isLaser = (selected.getAttribute('data-branding') || '').toLowerCase().indexOf('uv') === -1;
      var accepted = [];
      Array.prototype.slice.call(fileList).forEach(function (file) {
        var ext = fileExt(file.name);
        if (allowed.indexOf(ext) === -1) rejectFile(file.name, ext, isLaser);
        else accepted.push(file);
      });
      if (accepted.length) clearError();
      accepted.forEach(function (file) {
        var row = renderRow(file.name);
        var p = readAsPayload(file)
          .then(function (payload) {
            return fetch(driveUrl, {
              method: 'POST',
              body: JSON.stringify({ files: [payload], folder: folder }),
              redirect: 'follow',
              headers: { 'Content-Type': 'text/plain' }
            });
          })
          .then(function (res) { return res.json(); })
          .then(function (result) {
            if (result && result.success && result.files && result.files.length) {
              var f = result.files[0];
              row.setDone(f.filename + ': ' + f.url);
            } else { row.setError(); }
          })
          .catch(function () { row.setError(); });
        pending.push(p);
      });
    }

    if (uploadWrap && fileInput) {
      if (dropBtn) dropBtn.addEventListener('click', function () { fileInput.click(); });
      fileInput.addEventListener('change', function () { uploadFiles(fileInput.files); fileInput.value = ''; });
      ['dragenter', 'dragover'].forEach(function (ev) {
        uploadWrap.addEventListener(ev, function (e) { e.preventDefault(); uploadWrap.classList.add('is-drag'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        uploadWrap.addEventListener(ev, function (e) { e.preventDefault(); uploadWrap.classList.remove('is-drag'); });
      });
      uploadWrap.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files) uploadFiles(e.dataTransfer.files);
      });
    }

    // ---- add to cart ----
    var form = document.querySelector('.product-single__form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      if (!selected) return; // None selected: let the theme add just the part.

      e.preventDefault();
      e.stopImmediatePropagation();

      var variantSelect = form.querySelector('[name="id"]');
      var quantityInput = form.querySelector('[name="quantity"]');
      var btn           = form.querySelector('[data-add-to-cart]');
      var partVariant   = parseInt(variantSelect ? variantSelect.value : 0, 10);
      var quantity      = parseInt(quantityInput ? quantityInput.value : 1, 10) || 1;
      if (!partVariant) return;

      var serviceVariant = parseInt(selected.getAttribute('data-variant'), 10);
      var branding       = selected.getAttribute('data-branding');

      var textEl = btn ? btn.querySelector('[data-add-to-cart-text]') : null;
      function setBtnLoading(loading) {
        if (!btn) return;
        btn.disabled = loading;
        btn.classList.toggle('btn--loading', loading);
        if (textEl) textEl.textContent = loading ? '...' : (textEl.getAttribute('data-default-text') || 'Add to cart');
      }
      setBtnLoading(true);

      Promise.all(pending.map(function (p) { return p.catch(function () {}); }))
        .then(function () {
          if (!uploadedLinks.length) { setBtnLoading(false); showError(); return; }

          var ref = genRef();
          var artwork = uploadedLinks.join('   |   ');

          // Dedupe: if this exact part variant is already in the cart with a
          // branding option, remove that part line and its paired service line
          // first, so re-adding replaces rather than stacks (never two on one part).
          return getCart().then(function (cart) {
            var killRefs = {}, killKeys = [];
            (cart.items || []).forEach(function (it) {
              var r = it.properties && it.properties['_branding_ref'];
              if (r && it.variant_id === partVariant && SERVICE_VARIANTS.indexOf(it.variant_id) === -1) {
                killRefs[r] = true; killKeys.push(it.key);
              }
            });
            (cart.items || []).forEach(function (it) {
              var r = it.properties && it.properties['_branding_ref'];
              if (r && killRefs[r] && killKeys.indexOf(it.key) === -1) killKeys.push(it.key);
            });
            return removeLineKeys(killKeys);
          })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                items: [
                  { id: partVariant, quantity: quantity, properties: { 'Branding': branding, 'Artwork': artwork, '_branding_ref': ref } },
                  { id: serviceVariant, quantity: 1, properties: { '_branding_ref': ref, 'Applies to': partTitle } }
                ]
              })
            });
          })
          .then(function () { return getCart(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            document.dispatchEvent(new CustomEvent('cart:build'));
            openCartDrawer();
            setBtnLoading(false);
          });
        })
        .catch(function () { setBtnLoading(false); form.submit(); });
    }, true); // capture phase, before the theme's own handler
  }

  // ---- Cart reconciliation (runs on every page) ------------------------------
  // Removes any service line whose _branding_ref no longer has a matching part
  // line. This makes "remove the part" also remove its paired service line, and
  // never blanket-removes branding on other parts.

  var reconciling = false;
  function reconcileCart() {
    if (reconciling || !SERVICE_VARIANTS.length) return;
    reconciling = true;
    getCart().then(function (cart) {
      var items = cart.items || [];
      var partRefs = {};
      items.forEach(function (it) {
        var r = it.properties && it.properties['_branding_ref'];
        if (r && SERVICE_VARIANTS.indexOf(it.variant_id) === -1) partRefs[r] = true;
      });
      var orphanKeys = [];
      items.forEach(function (it) {
        var r = it.properties && it.properties['_branding_ref'];
        if (r && SERVICE_VARIANTS.indexOf(it.variant_id) !== -1 && !partRefs[r]) orphanKeys.push(it.key);
      });
      if (!orphanKeys.length) { reconciling = false; guardFromCart(cart); return; }
      removeLineKeys(orphanKeys).then(function () {
        reconciling = false;
        document.dispatchEvent(new CustomEvent('cart:build'));
      });
    }).catch(function () { reconciling = false; });
  }

  // ---- Service-only cart guard ----------------------------------------------
  // Laser and UV marking are services applied to a part, so a cart holding
  // nothing but marking services has nothing to mark. Block checkout until a
  // product is in the cart, and say why.

  var SERVICE_ONLY = false;
  var GUARD_MSG = 'Laser and UV marking are add-on services. Add the product you want marked, then check out.';

  function guardFromCart(cart) {
    var items = (cart && cart.items) || [];
    var hasService = false, hasProduct = false;
    items.forEach(function (it) {
      if (SERVICE_VARIANTS.indexOf(it.variant_id) !== -1) hasService = true;
      else hasProduct = true;
    });
    SERVICE_ONLY = hasService && !hasProduct;
    applyGuard();
  }

  function guardStyles() {
    if (document.getElementById('ServiceOnlyGuardCSS')) return;
    var s = document.createElement('style');
    s.id = 'ServiceOnlyGuardCSS';
    s.textContent =
      '.service-only-note{margin:10px 0 0;padding:10px 12px;border:1px solid #cc0000;border-radius:3px;' +
      'background:#fff1f1;color:#a30000;font-size:13px;line-height:1.45;font-weight:600;text-align:left}' +
      'html.cart-service-only .additional-checkout-buttons{display:none !important}' +
      'html.cart-service-only button[name="checkout"]{opacity:0.45;cursor:not-allowed}';
    document.head.appendChild(s);
  }

  function applyGuard() {
    guardStyles();
    document.documentElement.classList.toggle('cart-service-only', SERVICE_ONLY);
    document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
      btn.disabled = SERVICE_ONLY;
      btn.setAttribute('aria-disabled', SERVICE_ONLY ? 'true' : 'false');
      var wrap = btn.parentNode;
      if (!wrap) return;
      var note = wrap.querySelector('.service-only-note');
      if (SERVICE_ONLY && !note) {
        note = document.createElement('p');
        note.className = 'service-only-note';
        note.textContent = GUARD_MSG;
        wrap.insertBefore(note, btn.nextSibling);
      } else if (!SERVICE_ONLY && note) {
        note.parentNode.removeChild(note);
      }
    });
  }

  // The drawer and the cart page both re-render themselves, so re-apply the
  // disabled state whenever the DOM changes (debounced, and a no-op when the
  // state already matches).
  var guardTimer = null;
  function scheduleGuard() {
    if (guardTimer) return;
    guardTimer = setTimeout(function () { guardTimer = null; applyGuard(); }, 80);
  }

  // Last line of defence: catch the click and the form post themselves, in
  // case a re-render lands between the guard running and the customer tapping.
  document.addEventListener('click', function (e) {
    if (!SERVICE_ONLY) return;
    var t = (e.target && e.target.closest) ? e.target.closest('[name="checkout"], .additional-checkout-buttons') : null;
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    applyGuard();
  }, true);

  document.addEventListener('submit', function (e) {
    if (!SERVICE_ONLY) return;
    var f = e.target;
    if (!f || !f.querySelector || !f.querySelector('[name="checkout"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    applyGuard();
  }, true);

  function boot() {
    initSelector();
    reconcileCart();
    if (window.MutationObserver) {
      new MutationObserver(scheduleGuard).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-check after the theme re-renders the cart (drawer/page edits).
  document.addEventListener('cart:build', reconcileCart);
})();
